import { useEffect } from "react";
import { any, func, node, number, shape, string } from "prop-types";
import getYear from "date-fns/fp/getYear";
import parseISO from "date-fns/fp/parseISO";
import getQuarter from "date-fns/fp/getQuarter";

const propTypes = {
  children: node,
  height: number,
  hoveredYear: string, // YYYY
  margin: shape({ top: number, left: number }),
  onYearHover: func.isRequired,
  svgRef: shape({ current: any }).isRequired,
  xScale: func.isRequired, // d3-scale
};

const YearHoverLine = (props) => {
  const {
    children,
    height,
    hoveredYear,
    margin = {},
    onYearHover,
    svgRef,
    xScale, // d3 scaleTime
  } = props;

  const hoveredYearDate = parseISO(hoveredYear);

  /* handle mouse move */
  useEffect(() => {
    if (svgRef.current) {
      const handleMouseMove = (e) => {
        if (svgRef.current && onYearHover) {
          const xMousePosition =
            e.clientX -
            svgRef.current.getBoundingClientRect().left -
            (margin.left || 0);

          // don't let the user hover outside the xscale range
          const xRange = xScale.range();
          if (xMousePosition < xRange[0] || xMousePosition > xRange[1]) {
            return;
          }

          // do we need to constrain the y position too?

          const date = xScale.invert(xMousePosition);

          // figure out what year we're closest to
          // There might be a better way: https://spectrum.chat/date-fns/support/getting-closest-year-to-a-given-date~e3000a9b-4232-4428-bbf1-2594bf6f2d03
          const quarter = getQuarter(date); // 1, 2, 3, or 4
          const year = getYear(date) + (quarter < 3 ? 0 : 1);
          onYearHover(year.toString());
        }
      };

      const svgEl = svgRef.current;

      svgEl.addEventListener("mousemove", handleMouseMove);

      return () => svgEl.removeEventListener("mousemove", handleMouseMove);
    }
  });

  if (!hoveredYear) {
    return null;
  }

  return (
    <g className="year-hover-line">
      <text
        x={xScale(hoveredYearDate)}
        y={-40}
        textAnchor="middle"
        className="year-hover-line__text"
      >
        {hoveredYear}
      </text>
      <line
        className="year-hover-line__line"
        x1={xScale(hoveredYearDate)}
        y1="-30"
        x2={xScale(hoveredYearDate)}
        y2={height}
        style={{ pointerEvents: "none" }}
      />
      {children}
    </g>
  );
};

YearHoverLine.propTypes = propTypes;
export default YearHoverLine;
